/**
 * surgicalRegulating.js - 2026-10-18 (Tab 3 review, Dr. Tatar: surgical regulating)
 *
 * Values of the surgical regulating: the cases that the Role 2 Basic of a brigade cannot take (above the capacity at which its teams
 * would go into crisis tempo) are routed to a NEIGHBOUR Role 2 Basic, to the Role 2 ENHANCED and to the Role 3, in that order, as far
 * as each has capacity and is accessible (Tab 3 switches). Each diverted case pays the extra transit.
 *
 * STATUS of the values: EDUCATED GUESS (no source): the shares of the Role 2 Enhanced and Role 3 capacity that one brigade can use
 * (one third: a division of three brigades), the share of a neighbour Role 2 Basic available, its distance. The extra transit uses the
 * ground evacuation time of the calculator (3 minutes per km, the figure of its Role 2 to Role 3 leg). The surgical teams of the
 * facilities come from SURGICAL_CAPACITY_BY_MTF (surgicalCapacity.js).
 */
import { SURGICAL_CAPACITY_BY_MTF } from './surgicalCapacity';

export const SURGICAL_REGULATING_STATUS = Object.freeze({
  status: 'EDUCATED_GUESS',
  basis: 'Shares of the Role 2 Enhanced and Role 3 capacity for one brigade (1/3), neighbour Role 2 Basic share and distance: guesses. Extra transit: 3 min per km as in the Role 2 to Role 3 leg of the calculator. Teams per facility: SURGICAL_CAPACITY_BY_MTF.'
});

/** Order in which the excess is offered. */
export const REGULATING_DESTINATIONS = Object.freeze(['NEIGHBOUR_R2B', 'ROLE2_ENHANCED', 'ROLE3']);

/** Extra transit of a diverted case, minutes per km of ground evacuation (the calculator's Role 2 to Role 3 leg uses 3). */
export const EXTRA_TRANSIT_MIN_PER_KM = 3;

/** Defaults shown in Tab 3 and used when the planner has not set them. */
export const REGULATING_DEFAULTS = Object.freeze({
  enabled: true,
  neighbour_r2b_enabled: false,       // in a brigade scenario the neighbour is an assumption the planner makes explicit
  neighbour_r2b_share_percent: 25,    // share of one Role 2 Basic's normal capacity the neighbour can give
  neighbour_r2b_distance_km: 20,
  r2e_share_percent: 33,              // share of the Role 2 Enhanced capacity for this brigade (a division of three brigades)
  r3_share_percent: 33
});

/** Surgical teams (team equivalents) of the facility types, from the capacity table. */
export const FACILITY_SURGICAL_TEAMS = Object.freeze({
  ROLE2_ENHANCED: SURGICAL_CAPACITY_BY_MTF.ROLE_2_ENHANCED.surgical_teams,
  ROLE3: SURGICAL_CAPACITY_BY_MTF.ROLE_3.surgical_teams
});

if (!(FACILITY_SURGICAL_TEAMS.ROLE2_ENHANCED > 0) || !(FACILITY_SURGICAL_TEAMS.ROLE3 > 0)) {
  throw new Error('surgicalRegulating: SURGICAL_CAPACITY_BY_MTF needs surgical_teams for ROLE_2_ENHANCED and ROLE_3');
}
